import { render } from "./SoustractionStatique.vue?vue&type=template&id=6734939d&scoped=true"
import script from "./SoustractionStatique.vue?vue&type=script&lang=js"
export * from "./SoustractionStatique.vue?vue&type=script&lang=js"

import "./SoustractionStatique.vue?vue&type=style&index=0&id=6734939d&scoped=true&lang=css"

import exportComponent from "/Volumes/FITS/Projets-VueJs/montessori-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6734939d"]])

export default __exports__